// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


  //Modification comments 
  const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');
  
  commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
  })

  
  // Home select Annuaire
  if (document.body.classList.contains('home')) {
    const annuaireBtn = document.querySelector('.home-annuaire__btn');

    annuaireBtn.addEventListener('click', () => {
        let urlAnnuaire = document.getElementById('home-annuaire__category').value;

        if ( urlAnnuaire != '#' ) {
            window.location.href = urlAnnuaire;
        }
    });
  }